import { render, staticRenderFns } from "./ParosNoAsignados.vue?vue&type=template&id=4ee87b72&"
import script from "./ParosNoAsignados.vue?vue&type=script&lang=js&"
export * from "./ParosNoAsignados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports